var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44629 10.9269H16.607C16.6177 10.9269 16.6311 10.9269 16.6418 10.9242C16.7597 10.9055 16.8374 10.7956 16.8186 10.6778L15.7418 4.03493C15.7258 3.93047 15.6347 3.85547 15.5302 3.85547H8.52307C8.41861 3.85547 8.32754 3.93047 8.31147 4.03493L7.23468 10.6778C7.232 10.6885 7.232 10.7019 7.232 10.7126C7.232 10.8305 7.32843 10.9269 7.44629 10.9269ZM9.88915 5.6769H14.1615L14.7159 9.10547H9.332L9.88915 5.6769ZM9.95611 13.2492C9.94004 13.1448 9.84897 13.0698 9.7445 13.0698H2.73736C2.6329 13.0698 2.54182 13.1448 2.52575 13.2492L1.44897 19.8921C1.44629 19.9028 1.44629 19.9162 1.44629 19.9269C1.44629 20.0448 1.54272 20.1412 1.66057 20.1412H10.8213C10.832 20.1412 10.8454 20.1412 10.8561 20.1385C10.974 20.1198 11.0516 20.0099 11.0329 19.8921L9.95611 13.2492ZM3.54897 18.3198L4.10343 14.8912H8.37575L8.93022 18.3198H3.54897ZM22.5508 19.8921L21.474 13.2492C21.4579 13.1448 21.3668 13.0698 21.2624 13.0698H14.2552C14.1508 13.0698 14.0597 13.1448 14.0436 13.2492L12.9668 19.8921C12.9641 19.9028 12.9641 19.9162 12.9641 19.9269C12.9641 20.0448 13.0606 20.1412 13.1784 20.1412H22.3391C22.3499 20.1412 22.3633 20.1412 22.374 20.1385C22.4891 20.1198 22.5695 20.0099 22.5508 19.8921ZM15.0668 18.3198L15.6213 14.8912H19.8936L20.4481 18.3198H15.0668Z",
    fill: "url(#paint0_linear_2140_43081)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2140_43081",
    x1: 2.15812,
    y1: -2.16319,
    x2: 24.2167,
    y2: -1.27583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC165"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldIcon);
export default __webpack_public_path__ + "static/media/gold-icon.11b7e5f0a95af6d77258f432ff0b7061.svg";
export { ForwardRef as ReactComponent };